import {Repository, createRepository} from '@/repositories/Base/Repository'

class IntegrationRepository extends Repository {
    endpoint = 'vns/integrations'

    fetchAll(params) {
        return this.$axios.get(`${this.endpoint}/table`, {params})
    }

    search(params) {
        return this.$axios.get(`${this.endpoint}/list`, {params})
    }

    fetch(id) {
        return this.$axios.get(`${this.endpoint}/${id}/show`)
    }

    post(params) {
        return this.$axios.post(`${this.endpoint}/store`, params)
    }

    put(id, params) {
        // return this.$axios.put(`${this.endpoint}/${id}`, params)
        return this.$axios.post(`${this.endpoint}/store`, {...params, id: id})
    }

    fetchTypes(params) {
        return this.$axios.get(`${this.endpoint}/types`, {params})
    }

    fetchEquipments(params) {
        return this.$axios.get(`mapping/integration/exams/equipments`, {params})
    }
}

export default new IntegrationRepository()

export const create = createRepository(IntegrationRepository)
